/**
 * As cotas e os tetos do contrato para a moldura (`B-03`, ADR-070): só para o administrador,
 * lidos na entrada e a cada dez minutos. Sem o número, sem a faixa — quem diz o erro é a tela
 * de Administração, não a moldura.
 */
import { useEffect, useState } from "react";
import { api } from "../api/cliente";
import type { TetosDoContrato } from "../api/tipos";
import { RELEITURA_DAS_COTAS_MS } from "../cotas";
import { repetirComAbaVisivel } from "./repetirComAbaVisivel";

export function useTetosDoContrato(ativo: boolean): TetosDoContrato | null {
  const [tetos, definirTetos] = useState<TetosDoContrato | null>(null);
  useEffect(() => {
    if (!ativo) return;
    let vivo = true;
    const ler = () => {
      api<TetosDoContrato>("/admin/cotas")
        .then((lidos) => {
          if (vivo) definirTetos(lidos);
        })
        .catch(() => undefined);
    };
    ler();
    const parar = repetirComAbaVisivel(ler, RELEITURA_DAS_COTAS_MS);
    return () => {
      vivo = false;
      parar();
    };
  }, [ativo]);
  return ativo ? tetos : null;
}
